import jsonFormatAuth from "../../apis/jsonFormatAuth";

export const getPresignedUrls = ({ axiosFetch, imageList }) => {
  axiosFetch({
    axiosInstance: jsonFormatAuth(),
    method: "POST",
    url: "entries/image_presigned_urls/",
    sendSignal: false,
    requestConfig: {
      image_data: imageList,
    },
  });
};
